<template>
    <b-nav-item-dropdown text="Reportes"  v-show="isOK == true" left>   
        <b-dropdown-group id="dropdown-group-1" >
            <b-dropdown-item exact to="/home/poroperador">Por operador</b-dropdown-item>        
            <b-dropdown-item exact to="/home/pormaquina">Por maquina</b-dropdown-item>  
            <b-dropdown-item exact to="/home/pororden">Por orden</b-dropdown-item>
            <b-dropdown-item exact to="/home/porturno">Por turno</b-dropdown-item>
        </b-dropdown-group>
            
           
    </b-nav-item-dropdown>
</template>

<script>
    import {mapState,mapActions} from 'vuex'
    import customMixin from '@/mixins/customMixin'
    export default {
        mixins : [customMixin],
        data: function(){
            return {
                isOK: false
            }
        },
        mounted(){
            this.init()
        },
        computed:{
            ...mapState('login',['rol_id']),
            ...mapState('permiso',['permiso']), 
       
        },
        methods:{
            ...mapActions({
               _fetchPermisos: 'permiso/fetchPermisosUsuarios',
            }),
            init(){
                this._fetchPermisos(this.rol_id).then(() => {  
                    this.isOK =  this.isReporte(this.permiso) 
                })
            },
        }//end methods         
    }
</script>

<style lang="scss" scoped>

</style>